import Toast from 'ui/Toast'

export const handleRequestError = (error) => {
  if (error.response) {
    Toast({
      message: error.response.data.message || 'Server Error!',
      type: 'error',
    })
  } else {
    Toast({
      message: 'Server Error!',
      type: 'error',
    })
  }
}
